import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { debouncedFunction } from "../utils/helper";
import { UserLoginData } from "../components/common/charts/Enums";
import { setIsLoading } from "../redux/actions/commanAction";
import { defaultPageNo, defaultPageSize, URLS } from "../constants/constants";
import apiHelper from "../utils/apiHelper";
import { tr } from "date-fns/locale";

export const infiniteScrollHook = ({
  httpFetchDataFn,
  parentEntityId = null,
  isDependentEntity = false,
  FullyQualifiedFilters = null,
  FullyQualifiedSorts = null,
  filterEntityTypeId = undefined,
  filterEntityIds = undefined,
  dateFilterDateFilterTypeId = undefined,
  dateFilterClientDate = undefined,
  dateFilterStartDate = undefined,
  dateFilterEndDate = undefined,
  dateFilterDateField = undefined,
  pageSize = undefined
}) => {
  const dispatch: any = useDispatch();
  const orgId = parseInt(sessionStorage.getItem(UserLoginData.organization_id));
  const tenantId = parseInt(sessionStorage.getItem(UserLoginData.tenant_id)) || JSON.parse(sessionStorage.getItem("tenantInfo") || "{}").tenantId;
  const reqID = orgId ? isDependentEntity ? parentEntityId : orgId : isDependentEntity ? parentEntityId : tenantId;
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSortDirection, setCurrentSortDirection] = useState("asc");

  const [distinctFilterValues, setDistinctFilterValues] = useState<any>([]);
  const [aggregateValues, setAggregateValues] = useState<any>();
  const [formattedAggregateValues, setFormattedAggregateValues] = useState<any>();
  const [calculateValue, setcalculateValue] = useState<any>();



  const handleSort = () => {
    const newSortDirection = currentSortDirection === "asc" ? "desc" : "asc";
    setCurrentSortDirection(newSortDirection);
  };

  const concateOldRecords = (oldRecords = []) => {
    return [...oldRecords];
  };

  const fetchData = (page) => {
    var currPage = isNaN(page) ? currentPage : page;

    if (reqID) {
      setLoading(true);
      dispatch(setIsLoading(true));
      apiHelper(
        httpFetchDataFn,
        { showNotification: false },
        reqID,
        defaultPageSize,
        currPage,
        undefined,
        filterEntityTypeId,
        filterEntityIds,
        FullyQualifiedFilters,
        FullyQualifiedSorts,
        dateFilterDateFilterTypeId,
        dateFilterClientDate,
        dateFilterStartDate,
        dateFilterEndDate,
        dateFilterDateField,
        undefined,
        undefined
      )
        .then(({ data }) => {
          
          setLoading(false);
          if (distinctFilterValues.length == 0) {
            setDistinctFilterValues(data?.distinctFilterValues);
          }
          setAggregateValues(data?.aggregateValues);
          setFormattedAggregateValues(data?.formattedAggregateValues);
          setcalculateValue(data?.formattedCalculatedValues);
          setCurrentPage(currPage);
          dispatch(setIsLoading(false));
          setRowCount(data?.recordCount);
          if (currPage === 1) {
            setRows([...data?.success]);
          } else {
            setRows((prevRows) => [
              ...concateOldRecords(prevRows),
              ...data?.success,
            ]);
          }

          setHasMore(data?.recordCount > currPage * defaultPageSize);
        })
        .catch((e) => {
          setLoading(false);
          dispatch(setIsLoading(false));
          setRowCount(0);
          setRows([]);
          setHasMore(false);
        });
    } else
      console.log("No dependent information provided to fetch the records!");
  };

  useEffect(() => {
    setTimeout(() => {
      setRows([]);
    }, 500);
    debouncedFunction(() => fetchData(1), 500)();
  }, [FullyQualifiedFilters, FullyQualifiedSorts ,currentSortDirection]);

  return {
    loading,
    rows,
    rowCount,
    hasMore,
    distinctFilterValues,
    aggregateValues,
    formattedAggregateValues,
    calculateValue,
    fetchData,
    handleSort,
    currentSortDirection,
    currentPage
  };
};